import { Language } from './constants'

export type Lang = `${Language}`

export const treatExternalLocale = (lng?: string): Language => {
  if (lng?.match(/^pt/i)) {
    return Language.PT
  }

  if (lng && Object.values(Language)?.includes(lng as Language)) {
    return Language[lng.toUpperCase() as keyof typeof Language]
  }

  return Language.EN
}

export const capitalize = (str: string): string => {
  const result = str.toLowerCase()

  return result.charAt(0).toUpperCase() + result.slice(1)
}
